class HeaderDrawerController extends window.StimulusController {
  static targets = [
    "childLink",
    "childLinksList",
    "grandChildLinksList",
    "link",
  ];
  static outlets = ["header"];

  #activeLinkTitle = undefined;

  connect() {
    document.addEventListener(
      "drawer:toggle",
      this.toggleVisibility.bind(this),
    );
  }

  disconnect() {
    document.removeEventListener(
      "drawer:toggle",
      this.toggleVisibility.bind(this),
    );
  }

  toggleVisibility() {
    this.element.classList.toggle("tw-opacity-0");
    this.element.classList.toggle("tw-pointer-events-none");
  }

  preventClickPropagation(event) {
    event.stopPropagation();
  }

  toggleChildLinks(event) {
    this.#activeLinkTitle = event.target.dataset.linkTitle;
    this.#toggleLinkState(
      this.#activeLinkTarget,
      this.#activeChildListLinksTarget,
    );
  }

  toggleGrandChildLinks(event) {
    const idx = event.target.dataset.index;
    const childLink = this.#activeChildLinkTargets[idx];
    const grandChildList = this.#activeGrandChildLinksListTargets[idx];

    if (childLink) {
      this.#toggleLinkState(childLink, grandChildList, true);
    }
  }

  #toggleLinkState(link, childList, isGrandchild = false) {
    if (link) {
      link.classList.toggle("tw-bg-blue");
      link.classList.toggle("tw-text-white");

      if (isGrandchild) {
        link.classList.toggle("tw-bg-grey");
      }

      link
        .querySelector("[data-headerDrawer-target='caret']")
        .classList.toggle("tw-rotate-180");

      childList.classList.toggle("tw-max-h-0");
      childList.classList.toggle("tw-max-h-screen");
      childList.classList.toggle("tw-pointer-events-none");
    }
  }

  #findActiveTargetByTitle(targets) {
    return this[targets].find(
      (link) => link.dataset.linkTitle === this.#activeLinkTitle,
    );
  }

  #findActiveTargetsByTitle(targets) {
    return this[targets].filter(
      (link) => link.dataset.linkTitle === this.#activeLinkTitle,
    );
  }

  get #activeLinkTarget() {
    return this.#findActiveTargetByTitle("linkTargets");
  }

  get #activeChildListLinksTarget() {
    return this.#findActiveTargetByTitle("childLinksListTargets");
  }

  get #activeChildLinkTargets() {
    return this.#findActiveTargetsByTitle("childLinkTargets");
  }

  get #activeGrandChildLinksListTargets() {
    return this.#findActiveTargetsByTitle("grandChildLinksListTargets");
  }
}

Stimulus.register("headerDrawer", HeaderDrawerController);
